import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './views/AppContainer';
import * as serviceWorker from './serviceWorker';
import './assets/scss/autogestion.css?v=1.3.0';
require('./assets/img/autogestionicon2.png');

const initReact = () => {
  ReactDOM.render(<App />, document.getElementById('root'));
};

document.addEventListener("entorno-cargado", initReact);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
